export default __webpack_public_path__ + "static/media/sector_4w.c8615a79.jpg";